module.exports = __webpack_public_path__ + "media/battle.f3ed0ae0.mp3";